module.exports = __webpack_public_path__ + "img/03_1.aac8cdd6.png";